import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui";

import { LeafRadioList } from "./LeafRadioList";
import { byP } from "./leafOptions";
import type { PickProps, ReviewOption } from "./LeafTabs.types";

export function NewNamesTab({
  options,
  refreshCount,
  onRefresh,
  busy,
  picked,
  onPick,
}: PickProps & {
  options: ReviewOption[];
  refreshCount: number;
  onRefresh: () => void;
  busy: boolean;
}) {
  return (
    <div className="space-y-2 p-3">
      <Button variant="outline" disabled={busy} onClick={onRefresh}>
        <RefreshCw className="h-4 w-4" /> Refresh names ({refreshCount})
      </Button>
      <LeafRadioList
        options={options.filter((o) => !o.existing).sort(byP)}
        picked={picked}
        onPick={onPick}
      />
    </div>
  );
}
